import PestPillarLayout from "./PestPillarLayout";

const PROBLEMS = [
  {
    title: "Comment les reconnaître ?",
    desc: "Insecte brun-rouge de 4-7 mm, aplati, actif la nuit. Traces caractéristiques : petits points noirs sur les coutures du matelas, taches de sang sur les draps, morsures alignées en série de 3.",
  },
  {
    title: "D'où viennent-elles ?",
    desc: "Introduction par des bagages (hôtel, voyage), meubles d'occasion, textiles ramenés à domicile, ou propagation via murs mitoyens dans les logements collectifs.",
  },
  {
    title: "Risques sanitaires",
    desc: "Insomnie, anxiété, dermatites allergiques. Pas de transmission de maladies documentée, mais impact psychologique fort et invasion rapide (100+ œufs par femelle).",
  },
  {
    title: "Vapeur sèche 180 °C",
    desc: "Notre méthode principale : traitement thermique sans aucun produit chimique. Détruit adultes, larves et œufs sur matelas, sommier, canapé, plinthes en un passage.",
  },
  {
    title: "Biocides certifiés",
    desc: "En complément si l'infestation est étendue : insecticides homologués Certibiocide, protocole en 3 passages (J0, J+14, J+28) pour tuer les nymphes issues des œufs.",
  },
  {
    title: "Suivi et garantie",
    desc: "Contrôle post-traitement à J+28 : si vous constatez encore la présence de punaises, nous revenons sans surcoût jusqu'à éradication complète.",
  },
];

const METHOD = [
  { title: "Diagnostic gratuit", desc: "Visite sur place ou par photo. Identification certifiée (punaise de lit vs puce ou autre), évaluation de l'ampleur." },
  { title: "Préparation", desc: "Nous vous transmettons un protocole de préparation (lavage 60°, mise en sacs, aspiration) pour maximiser l'efficacité." },
  { title: "Traitement", desc: "Passage vapeur sèche 180 °C sur toute la literie et les zones-refuges. Application biocide ciblée si nécessaire." },
  { title: "Contrôle J+28", desc: "Retour pour vérifier l'absence de nouvelles morsures ou traces. 2ème passage inclus si besoin, garantie de résultat." },
];

const FAQ = [
  {
    q: "Combien coûte un traitement anti-punaises de lit en Creuse ?",
    a: "Pour un studio ou petite chambre : 150-250 €. Pour un appartement T2-T3 : 250-450 €. Pour une maison ou un gîte : 400-700 €. Le tarif inclut le diagnostic, le traitement complet, un 2ème passage à J+14 si nécessaire, et le contrôle à J+28. Devis gratuit personnalisé.",
  },
  {
    q: "La vapeur sèche est-elle vraiment efficace contre les punaises de lit ?",
    a: "Oui, à condition d'être bien menée. À 180 °C, la vapeur tue instantanément adultes, larves et œufs (température létale à partir de 60 °C). Elle pénètre dans les coutures, plinthes et fissures inaccessibles aux insecticides. C'est notre méthode privilégiée : aucun produit chimique, aucune éviction du logement, résultat immédiat.",
  },
  {
    q: "Faut-il jeter son matelas ?",
    a: "Non, dans 95 % des cas. La vapeur sèche traite efficacement le matelas et le sommier. Nous ne recommandons de jeter le matelas que dans deux cas : infestation ancienne massive avec tissu perforé (matelas déjà déformé), ou matelas très bas de gamme non lavable. Nous vous conseillons honnêtement lors du diagnostic.",
  },
  {
    q: "Combien de temps pour éradiquer complètement ?",
    a: "Le cycle complet dure 4 semaines : 1er traitement (J0), 2ème passage à J+14 pour tuer les nymphes issues des œufs éclos entre-temps, contrôle à J+28. Dans 90 % des cas, l'éradication est confirmée dès le 2ème passage. Nous garantissons le résultat : re-passages gratuits jusqu'à disparition complète.",
  },
  {
    q: "Comment éviter une nouvelle infestation ?",
    a: "Après un voyage : inspecter les bagages avant de les rentrer, laver textiles à 60 °C. Éviter les meubles/matelas d'occasion sans vérification. En logement collectif, colmater les passages de câbles avec les voisins. Vérifier régulièrement coutures du matelas et plinthes derrière la tête de lit.",
  },
  {
    q: "Intervenez-vous dans les gîtes et chambres d'hôtes en Creuse ?",
    a: "Oui, notre clientèle inclut de nombreux hébergeurs touristiques en Creuse (gîtes, chambres d'hôtes, campings). Nous proposons des contrats de prévention avec passages annuels de contrôle et intervention prioritaire en cas de suspicion. Confidentialité garantie, intervention en dehors des périodes d'occupation.",
  },
  {
    q: "Quelle différence entre punaise de lit et puce ?",
    a: "Les punaises de lit sont plus grandes (4-7 mm vs 2-3 mm pour les puces), ne sautent pas (contrairement aux puces qui bondissent), et vivent près des lits (les puces sont plutôt liées aux animaux). Les morsures de punaise se font en ligne de 3 (petit-déjeuner, déjeuner, dîner), celles de puce sont dispersées.",
  },
  {
    q: "Que faire en attendant votre intervention ?",
    a: "1) Ne changez pas de chambre (risque de propagation), 2) Ne pulvérisez pas d'insecticide grand public (cela disperse les punaises et complique le traitement), 3) Aspirez soigneusement le lit et les plinthes, 4) Lavez linge et textiles à 60 °C, mettez en sacs plastique scellés ce qui ne peut pas être lavé.",
  },
];

const CITIES = ["Guéret", "La Souterraine", "Aubusson", "Bourganeuf", "Boussac", "La Celle-Dunoise", "Felletin", "Bénévent-l'Abbaye", "Dun-le-Palestel", "Sainte-Feyre"];

export default function PunaisesDeLitCreuse() {
  return (
    <PestPillarLayout
      slug="punaises-de-lit-creuse"
      seoTitle="Punaises de lit Creuse — Vapeur 180°C | K'REUSE"
      seoDescription="Traitement anti-punaises de lit Creuse. Vapeur sèche 180°C + biocides. Protocole 3 passages, garantie résultat. Certibiocide."
      breadcrumbLabel="Punaises de lit Creuse"
      heroBadge="Anti-punaises de lit · Vapeur sèche 180 °C"
      heroTitleHtml={`Traitement <span class="font-medium text-[#1B5E20]">punaises de lit</span> en Creuse (23)`}
      heroSubtitle="Vapeur sèche 180 °C sans produit chimique. Protocole en 3 passages, contrôle à J+28. Garantie de résultat — nous revenons gratuitement jusqu'à éradication complète."
      hero_h2="Un cauchemar qui a une solution"
      introParagraphs={[
        "Les punaises de lit sont l'un des insectes nuisibles les plus difficiles à éliminer sans méthode professionnelle. Les traitements grand public (bombes insecticides, poudre, huiles essentielles) sont inefficaces et aggravent souvent l'infestation en dispersant les punaises dans d'autres pièces.",
        "K'REUSE EXTÉRIEUR utilise en priorité la vapeur sèche haute température (180 °C) qui tue instantanément adultes, larves et œufs. Notre appareil professionnel projette de la vapeur à haute pression, pénètre dans les coutures du matelas, les plinthes, les fissures et les tissus. Aucun produit chimique, aucune éviction du logement, résultat immédiat.",
        "Pour les infestations massives, nous complétons par un traitement biocide certifié Certibiocide en 2 ou 3 passages espacés de 14 jours, afin de tuer les nymphes issues des œufs qui éclosent après le premier passage. Contrôle systématique à J+28. Nous garantissons le résultat : si des punaises persistent, nous revenons sans surcoût.",
      ]}
      problems={PROBLEMS}
      method={METHOD}
      cities={CITIES}
      faq={FAQ}
      ctaTitle="Vous soupçonnez des punaises de lit ?"
      whatsappText="Bonjour, je pense avoir des punaises de lit. Merci de me rappeler pour un diagnostic."
    />
  );
}
